<div class="counter-container">
  <div class="hidden-value" *ngFor="let value of values">{{ value }}</div>
  <div class="counter" [class.sliding]="values.length > 1" [class.reverse]="values[0] === value">
    <div *ngFor="let value of values" class="counter-item">
      {{ value }}
    </div>
  </div>
</div>
